<div class="position-relative">
  <div class="w-75 mt-5 mx-auto">
    <p-error-notification
      [visible]="!!errorStatus && !!errorMessage"
      [message]="errorMessage"
      [status]="errorStatus"
      (notificationClick)="onNotificationClick()"
    ></p-error-notification>
  </div>

  <app-recapitulatif-read
    [mesInformations]="mesInformations"
    [monEntreprise]="monEntreprise"
    (updateStep)="onUpdateStep($event)"
  ></app-recapitulatif-read>

  <div *ngIf="isLoading" class="form-loading-overlay">
    <p-loader size="small"></p-loader>
  </div>

  <div class="captcha-field d-flex flex-column align-items-center mt-4">
    <div #captchaContainer></div>
  </div>
</div>
